import Pattern from '../ASSETS/Pattern.svg';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
